<template>
  <header :class="['header', { 'header--scrolled': scrolled }]">
    <div class="container header__inner">
      <router-link to="/" class="header__logo" @click.native="closeMenu">
        <span class="header__logo-icon">智</span>
        <span class="header__logo-text">{{ company.name }}</span>
      </router-link>

      <nav class="header__nav" :class="{ 'header__nav--open': menuOpen }">
        <router-link
          v-for="item in navItems"
          :key="item.label"
          :to="item.to"
          class="header__nav-link"
          active-class="header__nav-link--active"
          exact-active-class="header__nav-link--active"
          @click.native="closeMenu"
        >{{ item.label }}</router-link>
      </nav>

      <router-link
        :to="contactLink"
        class="btn btn-blue header__cta"
        @click.native="closeMenu"
      >预约演示</router-link>

      <button class="header__toggle" @click="menuOpen = !menuOpen" aria-label="菜单">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
import { company, navItems } from '../data/site'

export default {
  name: 'TheHeader',
  data() {
    return {
      company,
      navItems,
      scrolled: false,
      menuOpen: false
    }
  },
  computed: {
    contactLink() {
      const productPages = [
        '/cadre-management',
        '/smart-party',
        '/digital-village',
        '/comprehensive-governance',
        '/smart-inspection'
      ]
      if (productPages.includes(this.$route.path)) {
        return { path: this.$route.path, hash: '#contact' }
      }
      return '/contact'
    },
    hasHeroBackground() {
      const heroPages = ['/', ...['/cadre-management', '/smart-party', '/digital-village', '/comprehensive-governance', '/smart-inspection']]
      return heroPages.includes(this.$route.path) && !this.scrolled
    }
  },
  watch: {
    '$route'() {
      this.menuOpen = false
      this.$nextTick(() => {
        this.onScroll()
      })
    }
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 40
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 16px 0;
  transition: all 0.3s ease;
}

.header--scrolled {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  padding: 10px 0;
}

.header__inner {
  display: flex;
  align-items: center;
  gap: 32px;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.header__logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0052d9, #00a3ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
}

.header__logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  transition: color 0.3s ease;
}

.header__nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  justify-content: center;
}

.header__nav-link {
  padding: 8px 14px;
  font-size: 14px;
  color: #333;
  border-radius: 6px;
  transition: color 0.2s, background 0.2s;
  white-space: nowrap;
}

.header__nav-link:hover {
  color: #0052d9;
  background: #f0f5ff;
}

.header__nav-link--active {
  color: #0052d9;
  background: #f0f5ff;
}

.header__cta {
  flex-shrink: 0;
  padding: 10px 22px;
  font-size: 14px;
}

.header__toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.header__toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: background 0.3s ease;
}

/* 顶部蓝色背景区域：文字白色（桌面端导航） */
.header:not(.header--scrolled) .header__logo-text {
  color: #fff;
}

.header:not(.header--scrolled) .header__toggle span {
  background: #fff;
}

.header:not(.header--scrolled) .header__cta {
  background: #fff;
  color: #0052d9;
}

.header:not(.header--scrolled) .header__cta:hover {
  background: #f0f5ff;
}

@media (min-width: 961px) {
  .header:not(.header--scrolled) .header__nav-link {
    color: rgba(255, 255, 255, 0.92);
  }

  .header:not(.header--scrolled) .header__nav-link:hover,
  .header:not(.header--scrolled) .header__nav-link--active {
    color: #fff;
    background: rgba(255, 255, 255, 0.12);
  }
}

@media (max-width: 960px) {
  .header__nav {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    gap: 4px;
  }

  .header__nav--open {
    display: flex;
  }

  .header__nav-link {
    width: 100%;
    padding: 12px 16px;
    color: #333;
  }

  .header__nav-link:hover,
  .header__nav-link--active {
    color: #0052d9;
    background: #f0f5ff;
  }

  .header__cta {
    display: none;
  }

  .header__toggle {
    display: flex;
    margin-left: auto;
  }
}
</style>
